import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core'
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'

import { ButtonComponent } from '../../../components/button/button.component'
import { DateInputComponent } from '../../../components/date-input/date-input.component'
import { dateRangeValidator } from '../../../directives/validator/custom-validator'

import { AssessmentStore } from '../../../stores/assessment.store'

export type ExportAssessmentCsvDialogData = {
  csvType: 'Assessment' | 'KeyActionEvaluations'
}

export type ExportAssessmentCsvDialogResult = {
  startDate: Date | null
  endDate: Date | null
}

@Component({
  templateUrl: './export-assessment-csv.component.html',
  standalone: true,
  imports: [
    MatIcon,
    ReactiveFormsModule,
    MatTooltipModule,
    DateInputComponent,
    ButtonComponent,
    MatAutocompleteModule,
  ],
  providers: [AssessmentStore],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./export-assessment-csv.component.scss'],
})
export class ExportAssessmentCsvComponent implements OnInit {
  startDate = new FormControl<Date | null>(null)
  endDate = new FormControl<Date | null>(null)

  formGroup = this.formBuilder.group({
    startDate: this.startDate,
    endDate: this.endDate,
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExportAssessmentCsvDialogData,
    private matDialogRef: MatDialogRef<ExportAssessmentCsvComponent>,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    // 過去30日間をデフォルトの期間とする
    const today = new Date()
    this.endDate.setValue(today)
    const DEFAULT_PERIOD_DAYS = 30
    const pastDay = new Date(today)
    pastDay.setDate(pastDay.getDate() - DEFAULT_PERIOD_DAYS)
    this.startDate.setValue(pastDay)

    // フォーム全体のバリデーションを設定
    this.formGroup.setValidators(dateRangeValidator('startDate', 'endDate'))
  }

  submit(): void {
    if (this.formGroup.invalid) {
      return
    }

    // 時間は考慮せず、日付のみをエクスポートするため、startDateは00:00:00、endDateは23:59:59に設定する
    const startDate = this.startDate.value
    const endDate = this.endDate.value
    this.matDialogRef.close({
      startDate: startDate ? new Date(startDate.setHours(0, 0, 0, 0)) : null,
      endDate: endDate ? new Date(endDate.setHours(23, 59, 59, 999)) : null,
    })
  }

  close(): void {
    this.matDialogRef.close()
  }
}
